<section class="main-setup">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-6 mb-3">
        <div class="setup__content">
          <div class="row justify-content-center mb-2 pb-3">
            <img src="assets/logos/logo-inprovider.png" [attr.alt]="brandName" class="imgSizes">
          </div>

          <div class="text-center mb-4">
            <h4>Cambio de contraseña obligatorio</h4>
            <p class="text-muted">Debes establecer una nueva contraseña antes de continuar.</p>
          </div>

          @if (successMessage) {
            <div class="alert alert-success">{{ successMessage }}</div>
          }
          @if (errorMessage) {
            <div class="alert alert-danger">{{ errorMessage }}</div>
          }

          <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
            <div class="form-group mb-3">
              <label class="labeltext" for="currentpassword">Contraseña actual</label>
              <div class="password-input-wrapper">
                <input
                  id="currentpassword"
                  class="form-control"
                  [type]="showCurrentPassword ? 'text' : 'password'"
                  placeholder="Contraseña que usaste para ingresar"
                  formControlName="currentpassword"
                  autocomplete="current-password"
                />
                <button
                  type="button"
                  class="password-toggle-btn"
                  (click)="showCurrentPassword = !showCurrentPassword"
                  [attr.aria-label]="showCurrentPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
                >
                  <i class="far" [ngClass]="showCurrentPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                </button>
              </div>
              @if (changePasswordForm.controls['currentpassword'].touched && changePasswordForm.controls['currentpassword'].errors?.['required']) {
                <div class="texterror">Contraseña actual requerida</div>
              }
            </div>

            <div class="form-group mb-3">
              <label class="labeltext" for="password">Nueva contraseña</label>
              <div class="password-input-wrapper">
                <input
                  id="password"
                  class="form-control"
                  [type]="showPassword ? 'text' : 'password'"
                  placeholder="Mínimo 8 caracteres"
                  formControlName="password"
                  autocomplete="new-password"
                />
                <button
                  type="button"
                  class="password-toggle-btn"
                  (click)="showPassword = !showPassword"
                  [attr.aria-label]="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
                >
                  <i class="far" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                </button>
              </div>
              @if (changePasswordForm.controls['password'].touched && changePasswordForm.controls['password'].errors?.['required']) {
                <div class="texterror">Contraseña nueva requerida</div>
              }
              @if (changePasswordForm.controls['password'].touched && changePasswordForm.controls['password'].errors?.['minlength']) {
                <div class="texterror">Mínimo 8 caracteres</div>
              }
            </div>

            <div class="form-group mb-4">
              <label class="labeltext" for="confirmpassword">Confirmar contraseña</label>
              <div class="password-input-wrapper">
                <input
                  id="confirmpassword"
                  class="form-control"
                  [type]="showConfirmPassword ? 'text' : 'password'"
                  placeholder="Repite la nueva contraseña"
                  formControlName="confirmpassword"
                  autocomplete="new-password"
                />
                <button
                  type="button"
                  class="password-toggle-btn"
                  (click)="showConfirmPassword = !showConfirmPassword"
                  [attr.aria-label]="showConfirmPassword ? 'Ocultar confirmación' : 'Mostrar confirmación'"
                >
                  <i class="far" [ngClass]="showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                </button>
              </div>
              @if (changePasswordForm.controls['confirmpassword'].touched && changePasswordForm.controls['confirmpassword'].errors?.['required']) {
                <div class="texterror">Confirmar contraseña requerida</div>
              }
              @if (changePasswordForm.controls['confirmpassword'].errors?.['matchOther'] && !changePasswordForm.controls['confirmpassword'].errors?.['required']) {
                <div class="texterror">Las contraseñas deben coincidir</div>
              }
            </div>

            <button
              type="submit"
              class="btn btn-outline-primary rounded-pill px-5 mx-auto d-block"
              [disabled]="changePasswordForm.invalid || submitting"
            >
              {{ submitting ? 'Guardando...' : 'Cambiar contraseña' }}
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
